var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "train" } },
    [
      _c(
        "div",
        { staticClass: "Lvone_tab" },
        _vm._l(_vm.tabOneList, function(item, index) {
          return _c("div", { key: index }, [
            _c(
              "div",
              {
                staticClass: "Onetabtext",
                class: { Onetabtext_1: index == _vm.Onetabtindex },
                on: {
                  click: function($event) {
                    return _vm.oneClick(index, item.id, item.type)
                  }
                }
              },
              [_vm._v(_vm._s(item.name))]
            )
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "voice", staticStyle: { position: "relative" } },
        [
          _c(
            "div",
            { staticClass: "tabBox" },
            [
              _vm._l(_vm.tabTwoList, function(t, key) {
                return _c(
                  "div",
                  {
                    key: key,
                    staticClass: "index_tabBox",
                    class: {
                      index_tabBox_after: key == _vm.tabIndex,
                      index_tabBox_left:
                        key != 0 && key != _vm.tabTwoList.length - 1,
                      index_tabbox_0: key == 0,
                      index_tabbox_last: key == _vm.tabTwoList.length - 1,
                      index_tabbox_fristss:
                        key == 0 && _vm.tabTwoList.length - 1 == 0
                    },
                    on: {
                      click: function($event) {
                        return _vm.changeSecondaryTab(key, t.categoryId, t)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(t.categoryName) + "\n      ")]
                )
              }),
              _vm._v(" "),
              _vm.showAskingDoor
                ? _c(
                    "a",
                    {
                      staticStyle: {
                        position: "absolute",
                        top: "14px",
                        right: "20px",
                        "z-index": "9"
                      },
                      attrs: {
                        target: "_blank",
                        href:
                          _vm.imUrl +
                          "/TJ_TJK_IMAction.html?token=" +
                          _vm.imToken +
                          "&tjkId=" +
                          _vm.tjkInfo.id +
                          "&userName=" +
                          _vm.tjkInfo.realName +
                          "&tjkNumber=" +
                          _vm.tjkInfo.tjkNum +
                          "&platform=assitant"
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { height: "30px" },
                        attrs: {
                          src: require("@/assets/images/zx.png"),
                          alt: ""
                        }
                      })
                    ]
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-content" },
            [
              _vm.newPeopleBadgeId == false
                ? _c(
                    "div",
                    [
                      _c(
                        "el-dialog",
                        {
                          attrs: {
                            title: "注意",
                            visible: _vm.dialogVisible,
                            width: "30%",
                            "show-close": false,
                            "close-on-click-modal": false
                          },
                          on: {
                            "update:visible": function($event) {
                              _vm.dialogVisible = $event
                            }
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "完成前面的《系统测试》，才能报名技能提升培训"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "dialog-footer",
                              attrs: { slot: "footer" },
                              slot: "footer"
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.dialogVisible = false
                                    }
                                  }
                                },
                                [_vm._v("确 定")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType != "VoiceUpgradeSkill" &&
              _vm.assitantType != "OnlineUpgradeSkill" &&
              _vm.assitantType != "TjCollegeYingxiao" &&
              _vm.assitantType != "FbtOperate"
                ? _vm._l(_vm.courseList, function(c, key) {
                    return _c(
                      "div",
                      { key: key, staticClass: "step-list other-list" },
                      [
                        _c(
                          "div",
                          {
                            class: {
                              step: true,
                              active: c.passState == "Passed",
                              progress:
                                c.passState == "Ongoing" || c.passState == null
                            }
                          },
                          [
                            _vm.courseList.length != 1
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "circle",
                                    class: {
                                      circle: c.passState == "Passed",
                                      othercircle:
                                        c.passState == "Ongoing" ||
                                        c.passState == null
                                    }
                                  },
                                  [
                                    _vm.courseList.length != 1
                                      ? _c("div", [_vm._v(_vm._s(key + 1))])
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            key != 0
                              ? _c("div", {
                                  staticClass: "top_line",
                                  class: {
                                    top_isCheck:
                                      c.passState == "Passed" ||
                                      c.passState == "Ongoing",
                                    top_noCheck: c.passState == null
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.courseList.length > 1 &&
                            key != _vm.courseList.length - 1
                              ? _c("div", {
                                  class: {
                                    line: c.passState == "Passed",
                                    otherline:
                                      c.passState == "Ongoing" ||
                                      c.passState == null
                                  }
                                })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _c("div", { staticClass: "box boxstyle" }, [
                            _c(
                              "div",
                              { staticClass: "title" },
                              [
                                _c("div", [
                                  _c("span", { staticClass: "name" }, [
                                    _vm._v(_vm._s(c.courseName))
                                  ])
                                ]),
                                _vm._v(" "),
                                c.unlock
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          class:
                                            c.passState == "Passed"
                                              ? "isgreen"
                                              : "isred"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              c.passState == "Passed"
                                                ? "已完成"
                                                : "未完成"
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "test-button isposition"
                                        },
                                        [
                                          (c.assitantType == null ||
                                            c.assitantType == "" ||
                                            c.assitantType == "allSaleExam" ||
                                            c.assitantType == "fbt") &&
                                          c.courseType == "Integrate" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (c.assitantType == null ||
                                            c.assitantType == "" ||
                                            c.assitantType == "allSaleExam" ||
                                            c.assitantType == "fbt") &&
                                          c.courseType == "Integrate" &&
                                          c.passState == "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.courseType == "Exam" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("开始测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.courseType == "Exam" &&
                                          c.passState == "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.courseType != "Exam" &&
                                          c.assitantType == "fbtExamCourse"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goCompleteExperience(
                                                        c
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        c.gainBadge == true
                                                          ? "修改经验"
                                                          : "去完善"
                                                      )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType == "urlLink" &&
                                          c.unlock == true
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击跳转")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType ==
                                            "AssitantSpecialRobotExam" &&
                                          c.retry == "false" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("开始测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType ==
                                            "AssitantSpecialRobotExam" &&
                                          c.retry == "true" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    type: "primary"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("开始测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType == "WordInputExam" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.assitantType == "WordInputExam" &&
                                          c.passState == "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新测试")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (c.assitantType == null ||
                                            c.assitantType == "") &&
                                          c.courseType == "Linkage" &&
                                          c.passState != "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          (c.assitantType == null ||
                                            c.assitantType == "") &&
                                          c.courseType == "Linkage" &&
                                          c.passState == "Passed"
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.toStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.passState == "Ongoing" &&
                                          (c.assitantType == "beforeSaleExam" ||
                                            c.assitantType ==
                                              "afterSaleExam") &&
                                          c.unlock == true
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("点击学习")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          c.passState == "Passed" &&
                                          (c.assitantType == "beforeSaleExam" ||
                                            c.assitantType ==
                                              "afterSaleExam") &&
                                          c.unlock == true
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    size: "small"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.goStudy(c)
                                                    }
                                                  }
                                                },
                                                [_vm._v("重新学习")]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  : [_c("div", { staticClass: "lock" })]
                              ],
                              2
                            ),
                            _vm._v(" "),
                            c.courseType == "Integrate" ||
                            c.courseType == "Linkage"
                              ? _c("div", { staticClass: "text textstyle" }, [
                                  _vm._v(
                                    "\n                课程说明：\n                "
                                  ),
                                  c.result
                                    ? _c(
                                        "div",
                                        { staticStyle: { width: "70%" } },
                                        [
                                          _vm._v(_vm._s(c.description)),
                                          c.result
                                            ? _c(
                                                "span",
                                                { staticClass: "thespan" },
                                                [
                                                  _vm._v(
                                                    "(" + _vm._s(c.result) + ")"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _c("div", {
                                        staticStyle: { width: "70%" },
                                        domProps: {
                                          innerHTML: _vm._s(c.description)
                                        }
                                      })
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            c.courseType == "Exam"
                              ? _c("div", {
                                  staticClass: "text textstyle",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      "完成要求：" + c.description
                                    )
                                  }
                                })
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType == "OnlineUpgradeSkill"
                ? [
                    _vm._l(_vm.Onlinelist, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "RegistrationSessions" },
                        [
                          item.trainFlag == "theory"
                            ? _c("div", { staticClass: "label" }, [
                                _vm._v("理论培训")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.trainFlag == "exercise"
                            ? _c("div", { staticClass: "label" }, [
                                _vm._v("实操培训")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "text_box" }, [
                            _c("div", { staticClass: "title_state_button" }, [
                              _c("div", { staticClass: "title_state" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.trainTitle) +
                                    "\n                "
                                ),
                                item.passState != "signTimeOut"
                                  ? _c(
                                      "div",
                                      {
                                        class: {
                                          Reg_isred:
                                            item.passState != "passed" &&
                                            item.passState != "signTimeOut",
                                          Reg_isgreen:
                                            item.passState == "passed"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.passState != "passed" &&
                                                item.passState != "signTimeOut"
                                                ? "未完成"
                                                : "已完成"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              item.passState == "noJoin"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.togoscene(item)
                                        }
                                      }
                                    },
                                    [_vm._v("点击报名")]
                                  )
                                : item.passState == "alreadyApply"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button_noqian",
                                      on: {
                                        click: function($event) {
                                          return _vm.alertTrainNoStartOnline(
                                            item.startTime
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("等待培训")]
                                  )
                                : item.passState != "signTimeOut"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button special_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.gotest(item)
                                        }
                                      }
                                    },
                                    [_vm._v("点击学习")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            item.trainFlag == "exercise" ||
                            item.trainFlag == "theory"
                              ? _c("div", { staticClass: "Reg_date" }, [
                                  _vm._v(
                                    "\n              培训时间：" +
                                      _vm._s(item.startTime) +
                                      "-" +
                                      _vm._s(item.endTime) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.trainFlag == "exercise" ||
                            item.trainFlag == "theory"
                              ? _c("div", { staticClass: "Reg_lecturer" }, [
                                  _vm._v(
                                    "\n              培训模式：在线自学讲师帮扶\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState != "passed" &&
                            item.passState != "signTimeOut" &&
                            item.passState != "noJoin"
                              ? _c("div", { staticClass: "Reg_qq" }, [
                                  _vm._v(
                                    "\n              问题咨询： " +
                                      _vm._s(item.qqNumber) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_content" }, [
                              _vm._v("培训内容：" + _vm._s(item.trainContent))
                            ]),
                            _vm._v(" "),
                            item.passState == "signTimeOut"
                              ? _c("div", { staticClass: "fail_img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/images/fail.png"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fail_text" }, [
                                    _vm._v("已失效")
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.addGroupDialog.show,
                          width: "360px",
                          "show-close": false,
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(_vm.addGroupDialog, "show", $event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dialog_img" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/voiceScene/icon_tips.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "qq_text" }, [
                          _vm._v("确认参加培训并加入培训群")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "currency_button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "cancel",
                                  on: {
                                    click: function($event) {
                                      _vm.addGroupDialog.show = false
                                    }
                                  }
                                },
                                [_vm._v("取消")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "determine",
                                  on: { click: _vm.isenlist }
                                },
                                [_vm._v("确定")]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.dimensional,
                          width: "360px",
                          "close-on-click-modal": false,
                          center: ""
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dimensional = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dimensionalimg_Line" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dialog_img",
                            staticStyle: { "margin-top": "50px" }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/images/voiceScene/icon_tips.png"),
                                alt: ""
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "dimensionalimg_text" }, [
                              _vm._v("你已成功报名")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cel-button",
                                on: { click: _vm.qqsceneId }
                              },
                              [_vm._v("进入培训群")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType == "VoiceUpgradeSkill"
                ? [
                    _vm._l(_vm.cseList, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "RegistrationSessions" },
                        [
                          item.mode == "live" &&
                          item.sign == "Yes" &&
                          item.passState != "signTimeOut"
                            ? _c("div", { staticClass: "live_signed_badge" }, [
                                _vm._v("已签到")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "text_box" }, [
                            _c("div", { staticClass: "title_state_button" }, [
                              _c("div", { staticClass: "title_state" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.trainTitle) +
                                    "\n                "
                                ),
                                item.passState != "signTimeOut" &&
                                item.passState != "noJoin"
                                  ? _c(
                                      "div",
                                      {
                                        class: {
                                          Reg_isred:
                                            item.passState != "passed" &&
                                            item.passState != "signTimeOut",
                                          Reg_isgreen:
                                            item.passState == "passed"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.passState != "passed" &&
                                                item.passState != "signTimeOut"
                                                ? "未完成"
                                                : "已完成"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              item.mode == "self"
                                ? _c("div", [
                                    item.passState == "noJoin"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "Reg_button",
                                            on: {
                                              click: function($event) {
                                                return _vm.goscene(item)
                                              }
                                            }
                                          },
                                          [_vm._v("点击报名")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.passState != "noJoin" &&
                                    item.passState != "passed" &&
                                    item.passState != "signTimeOut"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "Reg_button special_button",
                                            on: {
                                              click: function($event) {
                                                return _vm.regoscene(
                                                  item.sceneId,
                                                  item.trainId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  点击学习"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.passState == "passed"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "Reg_button",
                                            on: {
                                              click: function($event) {
                                                return _vm.regoscene(
                                                  item.sceneId,
                                                  item.trainId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  重新学习"
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_date" }, [
                              _vm._v(
                                "\n              培训日期：" +
                                  _vm._s(item.startTime) +
                                  "-" +
                                  _vm._s(item.endTime) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "Reg_time" },
                              [
                                _vm._v("\n              培训时间："),
                                _vm._l(item.trainTime, function(m, key) {
                                  return _c("span", { key: key }, [
                                    _vm._v(_vm._s(m)),
                                    key < item.trainTime.length - 1
                                      ? _c("span", [_vm._v("，")])
                                      : _vm._e()
                                  ])
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_content" }, [
                              _vm._v("培训内容：" + _vm._s(item.trainContent))
                            ]),
                            _vm._v(" "),
                            item.mode == "live"
                              ? _c("div", { staticClass: "live_btns" }, [
                                  item.passState == "noJoin"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "Reg_button",
                                          on: {
                                            click: function($event) {
                                              return _vm.goscene(item)
                                            }
                                          }
                                        },
                                        [_vm._v("点击报名")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.passState != "noJoin" &&
                                  item.passState != "signTimeOut" &&
                                  item.sign != "Yes"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "Reg_button",
                                          on: {
                                            click: function($event) {
                                              return _vm.liveSignIn(item)
                                            }
                                          }
                                        },
                                        [_vm._v("点击签到")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.passState != "noJoin" &&
                                  item.passState != "signTimeOut" &&
                                  item.sign == "Yes"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "Reg_button special_button",
                                          on: {
                                            click: function($event) {
                                              return _vm.regoscene(
                                                item.sceneId,
                                                item.trainId
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("进入培训")]
                                      )
                                    : _vm._e()
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.passState == "signTimeOut"
                              ? _c("div", { staticClass: "fail_img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/images/fail.png"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fail_text" }, [
                                    _vm._v("已失效")
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.addGroupDialog.show,
                          width: "360px",
                          "show-close": false,
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(_vm.addGroupDialog, "show", $event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dialog_img" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/voiceScene/icon_tips.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "qq_text" }, [
                          _vm._v("确认参加培训并加入培训群")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "currency_button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "cancel",
                                  on: {
                                    click: function($event) {
                                      _vm.addGroupDialog.show = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                取消\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "determine",
                                  on: { click: _vm.isenlist }
                                },
                                [
                                  _vm._v(
                                    "\n                确定\n              "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.dimensional,
                          width: "360px",
                          "close-on-click-modal": false,
                          center: ""
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dimensional = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dimensionalimg_Line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "dimensionalimg" }, [
                          _c("img", {
                            attrs: { src: _vm.dimensionalimg, alt: "" }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "dimensionalimg_text" }, [
                          _vm._v("请使用手机QQ扫一扫加入培训群")
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cel-button",
                                on: { click: _vm.qqsceneId }
                              },
                              [_vm._v("已扫码加入")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType == "TjCollegeYingxiao"
                ? [
                    _vm._l(_vm.cseList, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "RegistrationSessions" },
                        [
                          _c("div", { staticClass: "text_box" }, [
                            _c("div", { staticClass: "title_state_button" }, [
                              _c("div", { staticClass: "title_state" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.trainTitle) +
                                    "\n                "
                                ),
                                item.passState != "signTimeOut" &&
                                item.passState != "noJoin"
                                  ? _c(
                                      "div",
                                      {
                                        class: {
                                          Reg_isred:
                                            item.passState != "passed" &&
                                            item.passState != "signTimeOut",
                                          Reg_isgreen:
                                            item.passState == "passed"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              item.passState != "passed" &&
                                                item.passState != "signTimeOut"
                                                ? "未完成"
                                                : "已完成"
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              item.passState == "noJoin"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.goscene(item)
                                        }
                                      }
                                    },
                                    [_vm._v("点击报名")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.passState != "noJoin" &&
                              item.passState != "passed" &&
                              item.passState != "noSignAlreadyOpen" &&
                              item.passState != "noSignedNoOpen" &&
                              item.passState != "signTimeOut"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button special_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.regoscene(
                                            item.sceneId,
                                            item.trainId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("\n                点击学习")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.passState == "passed"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.regoscene(
                                            item.sceneId,
                                            item.trainId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("\n                重新学习")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.passState == "noSignAlreadyOpen"
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "Reg_button",
                                      on: {
                                        click: function($event) {
                                          return _vm.signIn(
                                            item.sceneId,
                                            item.trainId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("点击签到")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.passState == "noSignedNoOpen"
                                ? _c(
                                    "div",
                                    { staticClass: "Reg_button_noqian" },
                                    [_vm._v("点击签到")]
                                  )
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_date" }, [
                              _vm._v(
                                "\n              培训日期：" +
                                  _vm._s(item.trainDate) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "Reg_time" },
                              [
                                _vm._v("\n              培训时间："),
                                _vm._l(item.trainTime, function(m, key) {
                                  return _c("span", { key: key }, [
                                    _vm._v(_vm._s(m)),
                                    key < item.trainTime.length - 1
                                      ? _c("span", [_vm._v("，")])
                                      : _vm._e()
                                  ])
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_lecturer" }, [
                              _vm._v(
                                "\n              培训讲师：" +
                                  _vm._s(item.teacherName) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_qq" }, [
                              _vm._v(
                                "\n              企业微信群：" +
                                  _vm._s(item.groupName) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "Reg_content" }, [
                              _vm._v("培训内容：" + _vm._s(item.trainContent))
                            ]),
                            _vm._v(" "),
                            item.passState == "signTimeOut"
                              ? _c("div", { staticClass: "fail_img" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/images/fail.png"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "fail_text" }, [
                                    _vm._v("已失效")
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.addGroupDialog.show,
                          width: "360px",
                          "show-close": false,
                          "close-on-click-modal": false
                        },
                        on: {
                          "update:visible": function($event) {
                            return _vm.$set(_vm.addGroupDialog, "show", $event)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dialog_img" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/images/voiceScene/icon_tips.png"),
                              alt: ""
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "qq_text" }, [
                          _vm._v(_vm._s(_vm.addGroupDialog.tip))
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "currency_button" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "cancel",
                                  on: {
                                    click: function($event) {
                                      _vm.addGroupDialog.show = false
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                取消\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "determine",
                                  on: { click: _vm.isenlist }
                                },
                                [
                                  _vm._v(
                                    "\n                确定\n              "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-dialog",
                      {
                        attrs: {
                          title: "",
                          visible: _vm.dimensional,
                          width: "360px",
                          "close-on-click-modal": false,
                          center: ""
                        },
                        on: {
                          "update:visible": function($event) {
                            _vm.dimensional = $event
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "dimensionalimg_Line" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dialog_img",
                            staticStyle: { "margin-top": "50px" }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/images/voiceScene/icon_tips.png"),
                                alt: ""
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "dialog-footer",
                            attrs: { slot: "footer" },
                            slot: "footer"
                          },
                          [
                            _c("div", { staticClass: "dimensionalimg_text" }, [
                              _vm._v("你已成功报名")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cel-button",
                                on: { click: _vm.qqsceneId }
                              },
                              [_vm._v("进入培训群")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.assitantType == "FbtOperate"
                ? [_c("trainList", { attrs: { categoryId: _vm.categoryId } })]
                : _vm._e()
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "考核次数",
            visible: _vm.theoryRemainDialog.show,
            width: "360px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.theoryRemainDialog, "show", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "总考核次数", "label-width": "150px" } },
                [
                  _c(
                    "el-link",
                    {
                      attrs: { type: "primary", underline: false },
                      on: {
                        click: function($event) {
                          return _vm.editRow(_vm.scope.row)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.theoryRemainDialog.total))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "剩余考核数", "label-width": "150px" } },
                [
                  _c(
                    "el-link",
                    {
                      attrs: { type: "primary", underline: false },
                      on: {
                        click: function($event) {
                          return _vm.editRow(_vm.scope.row)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.theoryRemainDialog.remain))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("div", { staticClass: "currency_button" }, [
                _c(
                  "div",
                  {
                    staticClass: "cancel",
                    on: {
                      click: function($event) {
                        _vm.theoryRemainDialog.show = false
                      }
                    }
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "determine",
                    on: { click: _vm.goThoryExamPage }
                  },
                  [_vm._v("确定")]
                )
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e4df7638", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e4df7638","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/index.vue
// module id = 1552
// module chunks = 0